import { replaceValue } from './replaceValue.js';

export const replaceValueMatching = (arr, test, newValue) => {
  const value = arr.find(test);

  return replaceValue(arr, value, newValue);
};